import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { apiService } from 'services/service';

export const useGetMeeting = () => {
    const [meeting, setMeeting] = useState(null);
    const [pagination, setPagination] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchMeeting = async () => {
        setIsLoading(true);
        try {
            const response = await apiService.get('/requests/crm/meetings');
            setMeeting(response?.data?.data);
            setPagination(response?.data?.info);
            return response?.data?.data;
        } catch (error) {
            console.log('Error from meeting', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchMeeting();
    }, []);

    return { meetings: meeting, isLoading, pagination };
};

export const useMeetingMutations = () => {
    const [isPending, setIsPending] = useState(false);

    const mutate = async (data) => {
        setIsPending(true);
        try {
            const response = await apiService.post({
                url: '/requests/crm/create-meetings',
                payload: data,
            });
            return response?.data;
        } catch (error) {
            console.log('Error from creating task', error);
            toast.error('Error creating task');
        } finally {
            setIsPending(false);
        }
    };

    return { mutate, isPending };
};
